import { useLocation, Navigate, useParams, useSearchParams } from "react-router-dom"
import { useEffect, useState } from "react"
import Cookies from 'js-cookie';
import { getValidateUser } from './AuthFetch'


export const setToken = (token) => {
    // var test=parseJwt(token)

    Cookies.set('token', token, { expires: 7, secure: true });

}

export const fetchToken = () => {

    return Cookies.get('token')
}
export const fetchRole = () => {
    let data = fetchDecodedData()

    return data?.roles
}
export const fetchGroup = () => {
    let data = fetchDecodedData()
    if(Array.isArray(data?.groups)){
       
        if(data.groups.includes('admin')|| data.groups.includes('DiploTeam')){
            return 'DiploTeam'
        
        }else if(data.groups.includes('ChatbotRegularUser')){
            return 'ChatbotRegularUser'
        }
        
        return group
    }else{
        return data?.groups

    }

}
export const fetchUsername = () => {
    let data = fetchDecodedData()
    return data?.username;
}

export const isAllowedToExportChatHistory = () => {
    const allowedUsers = [
        "jovank@diplomacy.edu", 
        "jovannj@diplomacy.edu", 
        "milosv@diplomacy.edu", 
        "anjadj@diplomacy.edu",
        "sorinat@diplomacy.edu",
        "andrejs@diplomacy.edu",
        "draganam@diplomacy.edu"
    ];

    return allowedUsers.includes(fetchUsername());
}

export const checkTokenTime = () => {
    let data = fetchDecodedData()
    if (data) {
        let toketdate = new Date(data['maxAge'])
        let timeNow = new Date().toISOString().split('T')[0];

        if (toketdate < timeNow) {
            return false;

        } else {
            return true;
        }
    }
    return true;
}

export const fetchDecodedData = () => {

    var data = Cookies.get('token')
    if (data) {
        return parseJwt(data)

    }
    return null
}

export const removeToken = () => {

    Cookies.remove('diplo', { path: '/' })

}

export function ViaVali({ children, ...props }) {
    let auth = fetchToken()
    let location = useLocation()
    let ViaToken = location.search.split('?key=')[1]

    if (!auth && !ViaToken) {

        return <Navigate to='/login' state={{ from: location }} />;
    }
    if (!auth) {
        setToken(ViaToken)

    }
    return children;
}
export function RequireAccess(access_id) {


    let auth = fetchToken()

    var access = ''
    if (access_id === 0 && auth) {
        access = true

    } else if (access_id === 1) {
        access = true


    } else {
        access = false
    }


    if (!access) {
        // console.log(access);
        document.location.href = '/login'
        return false
    } else {
        return true;

    }
}
export function OnlyPrivate(access_id) {
    let auth = fetchToken()

    var access = ''
    if (access_id === 0 && auth) {
        access = true

    } else if (access_id === 1 && auth) {
        access = true


    } else {
        access = false
    }
    return access
}
export function RequireToken({ children }) {


    let auth = fetchToken()
    let location = useLocation()
    if (!auth) {

        return <Navigate to='/login' state={{ from: location }} />;
    }

    return children;
}

export function CheckIfToken({ children, getError, setAuth, session_auth }) {
    const [searchParams, setSearchParams] = useSearchParams();
    var auth = fetchToken()
    let location = useLocation()
    let { token } = useParams();


    if (!auth && token && token.includes('token=')) {

        if (getValidateUser(token)) {
            setToken(token)
        }


    } else if (!auth && token && token.includes('error=')) {
        console.log(token)
    }

    if (fetchToken()) {

        return <Navigate to='/table-statistics' state={{ from: location }} />;
    }


    return children



}


function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}